import { StatusBadge } from '@/components/ds'
import { eetStatusLabel, eetStatusTone } from '@/containers/Receipts/receiptUtils'
import { EetSubmission } from '@invo.space/shared'

/** Stav odeslání do EET 2.0 jako tlumený odznak, POK pod ním (volitelně). */
export function EetStatusBadge({ submission, showPok = true }: { submission?: EetSubmission | null; showPok?: boolean }) {
  if (!submission) {
    return null
  }

  return (
    <div className="flex flex-col items-start gap-1">
      <StatusBadge status={eetStatusTone[submission.status]} label={eetStatusLabel[submission.status]} />
      {showPok && submission.pok && <span className="font-mono text-xs text-muted-foreground">{submission.pok}</span>}
    </div>
  )
}
